<app-table TableHeader='Consumer' [config]="true" [pageNation]="true" [paginationPageSizeSelector]="[10,20,50]" (onPageChange)="handlePageChange($event)" [maxRowCount]="totalcount"></app-table>
